export const RECEIVE_USERS = 'RECEIVE_USERS';
export const RECEIVE_USER = 'RECEIVE_USER';
export const SET_FILTER = 'SET_FILTER';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const ERROR = 'ERROR';
